function extractRechargeErrorMessage(error) {
  const possibleObjects = [error?.errors, error?.response?.errors, error?.data?.errors, error?.body?.errors, error?.body];

  for (const obj of possibleObjects) {
    const message = this.normalizeRechargeErrorMessage(obj);
    if (message) return message;
  }

  const rawMessage = String(error?.message || '').trim();

  if (!rawMessage) return '';

  const jsonStart = rawMessage.indexOf('{');
  const jsonEnd = rawMessage.lastIndexOf('}');

  if (jsonStart !== -1 && jsonEnd > jsonStart) {
    const maybeJson = rawMessage.slice(jsonStart, jsonEnd + 1);
    try {
      const parsed = JSON.parse(maybeJson);
      const parsedMessage = normalizeRechargeErrorMessage(parsed);
      if (parsedMessage) return parsedMessage;
    } catch {
      // Use fallback message below if JSON parsing fails.
    }
  }

  return rawMessage;
}

function normalizeRechargeErrorMessage(value) {
  if (!value) return '';

  if (Array.isArray(value)) {
    return value
      .map((entry) => normalizeRechargeErrorMessage(entry))
      .filter(Boolean)
      .join(' ');
  }

  if (typeof value === 'object') {
    return Object.values(value)
      .map((entry) => normalizeRechargeErrorMessage(entry))
      .filter(Boolean)
      .join(' ');
  }

  return String(value).trim();
}
